import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './loader.actions';
import { name } from './loader.consts';
import { LoaderStateModel } from './loader.state-model';

const defaults = {
  counter: 0,
};

@State<LoaderStateModel>({
  name,
  defaults,
})
@Injectable()
export class LoaderState {
  @Action(actions.ShowLoading)
  showLoading(ctx: StateContext<LoaderStateModel>) {
    const state = ctx.getState();
    ctx.patchState({
      counter: state.counter + 1,
    });
  }

  @Action(actions.HideLoading)
  hideLoading(ctx: StateContext<LoaderStateModel>) {
    const state = ctx.getState();
    if (state.counter > 0) {
      ctx.patchState({
        counter: state.counter - 1,
      });
    }
  }
}
